// ======================== OFFLINE BANNER ========================
// Bandeau permanent si hors ligne + status sync

import { useNetwork } from '../contexts/NetworkContext';
import { WifiOff, RefreshCw, Check, AlertTriangle } from 'lucide-react';

const OfflineBanner = () => {
  const { 
    isOnline, 
    showOfflineBanner, 
    syncInProgress, 
    pendingCount,
    setShowOfflineBanner 
  } = useNetwork();
  
  // Don't show if online and no pending items
  if (isOnline && pendingCount === 0 && !syncInProgress) {
    return null;
  }
  
  // Syncing state
  if (isOnline && syncInProgress) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-blue-500 text-white py-2 px-4 flex items-center justify-center gap-2 text-sm lg:pl-64">
        <RefreshCw className="w-4 h-4 animate-spin" />
        <span>Synchronisation en cours... ({pendingCount} en attente)</span>
      </div>
    );
  }
  
  // Pending items (online)
  if (isOnline && pendingCount > 0) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-green-500 text-white py-2 px-4 flex items-center justify-center gap-2 text-sm lg:pl-64">
        <Check className="w-4 h-4" />
        <span>En ligne - {pendingCount} élément(s) synchronisé(s)</span>
      </div>
    );
  }
  
  // Offline state
  if (!isOnline && showOfflineBanner) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-orange-500 text-white py-2 px-4 lg:pl-64">
        <div className="flex items-center justify-center gap-2 text-sm">
          <WifiOff className="w-4 h-4" />
          <span className="font-medium">Hors ligne</span>
          <span className="hidden sm:inline">– certaines actions sont désactivées</span>
        </div>
        {pendingCount > 0 && (
          <div className="text-xs text-center mt-1 opacity-90">
            {pendingCount} brouillon(s) en attente de synchronisation
          </div>
        )}
      </div>
    );
  }
  
  return null;
};

export default OfflineBanner;
